// new pay accordion
$(".accordion").on("click", function() {
    $(this).toggleClass("collapsed open");
    $(this).next().toggleClass("toggle");
});
